// Grilla de selects en vez de checkboxes — mismo criterio que ChecklistGrid
// (generalizar recién con el 2°/3er consumidor real): las "variables para
// identificar casos de near miss" de 051 necesitan preservar el "no"
// explícito (no solo "marcado"/"sin marcar" como el resto de los
// checklists de esta fase) — cada ítem imprime un par de radio sí/no (y a
// veces s/d) en el papel, y para vigilancia de near miss perder esa
// distinción es una pérdida real de fidelidad clínica.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export interface SelectGridProps {
  readonly claves: readonly string[];
  readonly opciones: readonly string[];
  readonly prefijoI18n: string;
  readonly prefijoI18nOpciones: string;
  readonly prefijoId: string;
  readonly valores: Readonly<Record<string, string>>;
  readonly onChange: (v: Record<string, string>) => void;
}

export function SelectGrid({ claves, opciones, prefijoI18n, prefijoI18nOpciones, prefijoId, valores, onChange }: SelectGridProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
      {claves.map((clave) => (
        <div key={clave} className="flex flex-col gap-1">
          <Label htmlFor={`${prefijoId}-${clave}`} className="text-sm font-normal">
            {t(`${prefijoI18n}.${clave}`)}
          </Label>
          <Select value={valores[clave] || undefined} onValueChange={(v) => onChange({ ...valores, [clave]: v })}>
            <SelectTrigger id={`${prefijoId}-${clave}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {opciones.map((op) => (
                <SelectItem key={op} value={op}>
                  {t(`${prefijoI18nOpciones}.${op}`)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
}
